import React from 'react';
import { Icon, Tooltip } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import type CustomField from 'App/resources/Model/CustomField';
import type FieldDependency from 'App/resources/Model/FieldDependency';
import { isVisibilityRule } from 'App/helpers/fieldDependencies';

type Props = {
	fieldId: number;
	customFields: Pick<CustomField, 'id' | 'name'>[];
	rules?: FieldDependency[];
};

const FieldDependencyMarker = ({ fieldId, customFields, rules = [] }: Props) => {
	const { t } = useTranslation();
	const rule = rules.find(rule => rule.fieldId === fieldId);
	const source = rule && customFields.find(field => field.id === rule.parentFieldId)?.name;
	if (!source) {
		return null;
	}
	return (
		<Tooltip
			title={t(
				isVisibilityRule(rule)
					? 'admin.fields.fieldDependency.shownWhen'
					: 'admin.fields.fieldDependency.dependsOnField',
				{ field: source }
			)}
		>
			<Icon name="sitemap" color="grey-10" space="mll" />
		</Tooltip>
	);
};

export default FieldDependencyMarker;
